export default "__VITE_ASSET__ChOIrOAD__"